module.exports = __webpack_public_path__ + "static/media/microsoft.54677eb3.svg";